import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userRoles = authService.getRoles();
  const requiredRoles = route.data['roles'] as string[];

  if (userRoles.includes('admin')) {
    return true;
  }

  if (requiredRoles.includes('client') && userRoles.includes('client')) {
    return true;
  }

  return router.createUrlTree(['/']);
};
